import Typography from '@mui/material/Typography';

export const Section = ({ backgroundColor, textColor, title }) => {
  return <div style={{ backgroundColor: backgroundColor, textColor: textColor, height: '100vh' }}>
    <Typography textAlign="center">{title}</Typography>
  </div>
}